import { emptyArray } from 'ui-components/default-props/empty';

export const mapShipFromToProductWarehouse = (sellerShipFrom, activeProductWarehouses = emptyArray) => {
  return {
    warehouseId: sellerShipFrom.shipFromId.toString(),
    warehouseName: sellerShipFrom.name,
    isSelected: activeProductWarehouses.find((pW) => pW.warehouseId.toString() === sellerShipFrom.shipFromId.toString())?.isSelected,
  };
};

export const mapMsdsProductOptionToMsdsFile = (msdsProductOption) => {
  if (!msdsProductOption?.value) {
    return null;
  }

  try {
    const file = JSON.parse(msdsProductOption.value);

    return {
      fileName: file.original_file_name,
      uploadDate: file.uploaded_at,
    };
  } catch {
    return null;
  }
};
